import type { ValidationDetail } from '../../types/api';

export class ApiError extends Error {
  status: number;
  details?: unknown;

  constructor(message: string, status: number, details?: unknown) {
    super(message);
    this.status = status;
    this.details = details;
  }

  /** { "billingAddress.pincode": "Invalid" } from the backend's validation details */
  fieldErrors(): Record<string, string> {
    const list = (Array.isArray(this.details) ? this.details : []) as ValidationDetail[];
    return Object.fromEntries(list.map((d) => [d.path, d.message]));
  }
}
